import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map, mergeMap, filter, delay, tap } from 'rxjs/operators';

import { CosyCommunicationControllerService, SearchOption, AttributeSearch } from '../../service/controller/cosy-communication-controller.service';
import { FlexSearchRequest, Filter } from '../../model/server/flexSearchRequest';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';
import { InterfaceElement, IEEntityList } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-cosy-flexbox',
  templateUrl: './cosy-flexbox.component.html',
  styleUrls: ['./cosy-flexbox.component.css']
})
export class CosyFlexboxComponent implements OnInit {
  @ViewChild('flexboxInput') flexboxInput: ElementRef;
  @Input() ie: InterfaceElement;
  @Input() entityFormGroup: FormGroup;
  myControl = new FormControl();

  options: any[] = [];
  filteredOptions: Observable<any[]>;
  flexboxDataFilter: any[];
  flexboxDataItem: FlexSearchRequest = new FlexSearchRequest();
  searchValue: string = '';
  flexSearchRequest: FlexSearchRequest = new FlexSearchRequest();
  pattern: RegExp = new RegExp('(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}');
  displayName: string = 'DisplayName';
  searchAtInit: boolean = true;
  ieValue: any;
  ua: string;
  date: Date;

  constructor(
    public cosyCommunicationControllerService: CosyCommunicationControllerService,
    private uxControllerService: UXControllerService,
    public datePipe: DatePipe
  ) {
   };

  ngOnInit() {
    if (this.ie.Values.length > 0) {
      this.ieValue = this.ie.Values[0].nil ? '' : this.ie.Values[0].Value;
      let ieValue = this.cosyCommunicationControllerService.searchResult.find(elements => elements.ID == this.ieValue);
      if (ieValue != null) {
        this.ieValue = ieValue.displayName;
        this.resetFlexbox()
      }
      else if (this.ie.CustomizeOptions.Properties.GetCosyDisplayName){
        this.cosyCommunicationControllerService.getDisplayNameForCOSYEntityRecord(this.uxControllerService.sessionID, this.uxControllerService.ieEntity.ObjectID, this.ie.ObjectName, this.ie.Values[0].Value).subscribe(
          displayName => {
            this.ieValue = displayName['value'];
            this.resetFlexbox()
          },
          () => this.resetFlexbox()
        );
      }
    }
    if (this.ie.CustomizeOptions.Properties.Multiline != null && this.ie.CustomizeOptions.Properties.Multiline) {
    }
    if (this.ie.CustomizeOptions.Properties.DisplayName != null) {
      this.displayName = this.ie.CustomizeOptions.Properties.DisplayName;
    }

    if (this.ie.CustomizeOptions.Properties.SearchAtInit != null) {
      this.searchAtInit = this.ie.CustomizeOptions.Properties.SearchAtInit;
    }
    this.ua = this.ie.Attributes.OnSelectUAID;
    if (this.ua == null) this.ua = this.ie.Attributes.OnChangeUAID;

    this.flexSearchRequest = this.configFilters();
    if (this.entityFormGroup == null) {
      this.filteredOptions = this.myControl.
        //get(this.ie.InterfaceElementID).valueChanges.pipe(
        valueChanges.pipe(
          filter(value => value !== '' && value !== this.searchValue && !this.pattern.test(value) && String(typeof value) !== 'object' && this.searchAtInit),
          tap(() => { this.date = new Date(); document.body.style.cursor = 'progress'; this.flexboxInput.nativeElement.style.cursor = 'progress'; }),
          delay(300),
          filter(() => this.date.getTime() - new Date().getTime() <= -290),
          startWith(this.ieValue),
          map(value1 => {
            console.log(typeof value1 + ' ' + value1 + ' ' + this.pattern.test(value1) + ' ' + this.pattern.source);
            this.searchValue = value1;
            this.flexSearchRequest.cosyToken = this.uxControllerService.sessionID;
            if (this.ie.DynamicMetaData != null) this.flexSearchRequest.entityID = this.ie.DynamicMetaData.ObjectID;
            if (this.ie.CustomizeOptions.Mode != null) this.flexSearchRequest.mode = this.ie.CustomizeOptions.Mode;
            else this.flexSearchRequest.mode = 'flex';
            if (this.ie.CustomizeOptions.WhereClause != null) {
              this.flexSearchRequest.whereClause = this.ie.CustomizeOptions.WhereClause.replace(/Searchtext/g, value1);
            }
            else if (this.ie.CustomizeOptions.System != null) {
              this.flexSearchRequest.searchText = value1;
            }
            else this.flexSearchRequest.searchText = value1;
            if (this.ie.CustomizeOptions.Attributes != null) this.flexSearchRequest.attributes = Object.keys(this.ie.CustomizeOptions.Attributes);
            if (this.ie.CustomizeOptions.WhatClause != null){ 
              let dateNow = this.datePipe.transform((new Date), 'yyyy-MM-dd H:mm:ss');
              this.flexSearchRequest.whatClause = this.ie.CustomizeOptions.WhatClause.replace(/Now/g, dateNow);
            }
            if (this.ie.CustomizeOptions.TableName != null) this.flexSearchRequest.tableName = this.ie.CustomizeOptions.TableName;
            if (this.ie.CustomizeOptions.System != null) this.flexSearchRequest.system = this.ie.CustomizeOptions.System;
          }),
          mergeMap(value2 => this.cosyCommunicationControllerService.getSearchData(this.flexSearchRequest).pipe(map(
            searchData => {
              this.options = [];

              let id: string;
              let displayName: string;
              let type: string = 'flex';
              let entityList: IEEntityList;
              if (searchData['EntityList'] != null) {
                entityList = searchData['EntityList'];
                if (entityList.RowItems != null) {
                  if ((this.flexSearchRequest.system == null || this.flexSearchRequest.system == 'cosy') && this.ie.CustomizeOptions.Attributes == null)
                    entityList.RowItems.forEach(item => { this.options.push({ 'ID': item.ID, 'DisplayName': item.DisplayName, 'type': type }) });
                  else {
                    let cosyAttributes: string[] = Object.keys(this.ie.CustomizeOptions.Attributes);
                    entityList.RowItems.forEach(item => {
                      let so: string = "{";
                      item.ColItems.forEach(colitem => {
                        cosyAttributes.forEach(cosyAttribute => {
                          if (colitem.Value == null) colitem.Value = '';
                          if (colitem.Name.toLowerCase() == cosyAttribute.toLowerCase()) so += '"' + cosyAttribute + '":"' + colitem.Value.replace(/"/g, '\\"') + '",';
                        });
                      });
                      so += '"type":"' + type + '"}';
                      this.options.push(JSON.parse(so));
                    });
                    if (entityList.RowItems.length == 0) {
                      let soEmty: string = "{";
                      cosyAttributes.forEach(cosyAttribute => {
                        if (cosyAttribute == 'DisplayName' || cosyAttribute == this.displayName) soEmty += '"' + cosyAttribute + '":"Keinen Eintrag gefunden",';
                        else soEmty += '"' + cosyAttribute + '":"",';
                      });
                      soEmty += '"type":"' + type + '"}';
                      this.options.push(JSON.parse(soEmty));
                    }
                  }
                }
                if (searchData['Filters'] != null) {
                  //this.flexboxDataItem.filters = searchData['Filters'];
                  //this.flexboxDataItem.filters.forEach(filter => { type=filter.type; filter.items.forEach(item => {this.options.push({'id': item.id, 'displayName':item.displayName, 'type': type})}); });
                }
              }
            }))
          ),
          map(value => this._filter(this.searchValue)),
          tap(() => { document.body.style.cursor = 'default'; this.flexboxInput.nativeElement.style.cursor = 'default'; })
        );
    }
    else {
      this.filteredOptions = this.entityFormGroup.
        get(this.ie.InterfaceElementID).valueChanges.pipe(
          filter(value => value !== '' && value !== this.searchValue && !this.pattern.test(value) && String(typeof value) !== 'object' && this.searchAtInit),
          tap(() => { this.date = new Date(); document.body.style.cursor = 'progress'; this.flexboxInput.nativeElement.style.cursor = 'progress'; }),
          delay(300),
          filter(() => this.date.getTime() - new Date().getTime() <= -290),
          startWith(this.ieValue),
          map(value1 => {
            console.log(typeof value1 + ' ' + value1 + ' ' + this.pattern.test(value1) + ' ' + this.pattern.source);
            this.searchValue = value1;
            this.flexSearchRequest.cosyToken = this.uxControllerService.sessionID;
            if (this.ie.DynamicMetaData != null) this.flexSearchRequest.entityID = this.ie.DynamicMetaData.ObjectID;
            if (this.ie.CustomizeOptions.Mode != null) this.flexSearchRequest.mode = this.ie.CustomizeOptions.Mode;
            else this.flexSearchRequest.mode = 'flex';
            if (this.ie.CustomizeOptions.WhereClause != null) {
              this.flexSearchRequest.whereClause = this.ie.CustomizeOptions.WhereClause.replace(/Searchtext/g, value1);
            }
            else if (this.ie.CustomizeOptions.System != null) {
              this.flexSearchRequest.searchText = value1;
              this.flexSearchRequest.system = this.ie.CustomizeOptions.System;
            }
            else this.flexSearchRequest.searchText = value1;
            if (this.ie.CustomizeOptions.Attributes != null) this.flexSearchRequest.attributes = Object.keys(this.ie.CustomizeOptions.Attributes);

          }),
          mergeMap(value2 => this.cosyCommunicationControllerService.getSearchData(this.flexSearchRequest).pipe(map(
            searchData => {
              this.options = [];

              let id: string;
              let displayName: string;
              let type: string = 'flex';
              let entityList: IEEntityList;
              if (searchData['EntityList'] != null) {
                entityList = searchData['EntityList'];
                if (entityList.RowItems != null) {
                  if ((this.flexSearchRequest.system == null || this.flexSearchRequest.system == 'cosy') && this.ie.CustomizeOptions.Attributes == null)
                    entityList.RowItems.forEach(item => { this.options.push({ 'ID': item.ID, 'DisplayName': item.DisplayName, 'type': type }) });
                  else {
                    let cosyAttributes: string[] = Object.keys(this.ie.CustomizeOptions.Attributes);
                    entityList.RowItems.forEach(item => {
                      let so: string = "{";
                      item.ColItems.forEach(colitem => {
                        cosyAttributes.forEach(cosyAttribute => {
                          if (colitem.Value == null) colitem.Value = '';
                          if (colitem.Name.toLowerCase() == cosyAttribute.toLowerCase()) so += '"' + cosyAttribute + '":"' + colitem.Value.replace(/"/g, '\\"') + '",';
                        });
                      });
                      so += '"type":"' + type + '"}';
                      this.options.push(JSON.parse(so));
                    });
                    if (entityList.RowItems.length == 0) {
                      let soEmty: string = "{";
                      cosyAttributes.forEach(cosyAttribute => {
                        if (cosyAttribute == 'DisplayName' || cosyAttribute == this.displayName) soEmty += '"' + cosyAttribute + '":"Keinen Eintrag gefunden",';
                        else soEmty += '"' + cosyAttribute + '":"",';
                      });
                      soEmty += '"type":"' + type + '"}';
                      this.options.push(JSON.parse(soEmty));
                    }
                  }
                }
                if (searchData['Filters'] != null) {
                  //this.flexboxDataItem.filters = searchData['Filters'];
                  //this.flexboxDataItem.filters.forEach(filter => { type=filter.type; filter.items.forEach(item => {this.options.push({'id': item.id, 'displayName':item.displayName, 'type': type})}); });
                }
              }
            }))
          ),
          map(value => this._filter(this.searchValue)),
          tap(() => { document.body.style.cursor = 'default'; this.flexboxInput.nativeElement.style.cursor = 'default'; })
        );

    }
  }

  private _filter(value: string): any[] {
    const filterValue = value.replace('%', '').toLowerCase();
    if (!this.searchAtInit) {
      this.searchAtInit = true;
      this.flexboxInput.nativeElement.value = this.ieValue;
      return this.options = [];
    }
  
    if (this.options.length == 1 && 
       ( (this.options[0].DisplayName == "Keinen Eintrag gefunden") || 
         (this.options[0][this.displayName] == "Keinen Eintrag gefunden")) ) return this.options;
    else return this.options;

    //else return this.options.filter(option => option[this.displayName].toLowerCase().includes(filterValue));
    //return this.options;
  }

  filterPostList(event) {
    var value = event.source.value;
    let so: SearchOption = new SearchOption();
    let sr: SearchOption = new SearchOption();
    so.attributes = [];
    so.type = value.type;
    let twi: string = JSON.stringify(event.source.value);

    if (this.ie.CustomizeOptions.Attributes != null) {
      Object.keys(this.ie.CustomizeOptions.Attributes).forEach(element => {
        let soAttribute: AttributeSearch = new AttributeSearch();
        soAttribute.name = element;
        soAttribute.value = event.source.value[element];
        so.attributes.push(soAttribute);
      });
    }

    so.ID = value.ID;
    so.displayName = value.DisplayName;
    this.cosyCommunicationControllerService.searchOption.push(so);

    if (value.type == 'flex') {
      let ie: InterfaceElement;
      let val: string;
      this.cosyCommunicationControllerService.searchOption.pop();
      if ((this.flexSearchRequest.system == null || this.flexSearchRequest.system == 'cosy') && this.ie.CustomizeOptions.Attributes == null) {
        this.uxControllerService.fetchIEUserAction(this.ua, this.ie, value.id, null, null, null, this.entityFormGroup, null);
        this.ie.Values[0].Value = value.DisplayName;
      }
      else {
        Object.keys(this.ie.CustomizeOptions.Attributes).forEach(cosyElement => {
          let attributeDetails: string[] = this.ie.CustomizeOptions.Attributes[cosyElement].split(':');
          if (event.source.value[cosyElement] != '') {
            if (typeof attributeDetails[1] != 'undefined' && attributeDetails[1] && event.source.value[cosyElement] != "Keinen Eintrag gefunden") {
              if (attributeDetails[1] != this.ie.InterfaceElementID) {
                ie = this.uxControllerService.getIEformEntity(attributeDetails[1]);
                this.uxControllerService.fetchIEUserAction(attributeDetails[2], ie, event.source.value[cosyElement], null, null, null, this.entityFormGroup, null);
              }
              else {
                this.uxControllerService.fetchIEUserAction(
                  this.ua, this.ie, event.source.value[cosyElement], null, null, null, this.entityFormGroup, null);
                sr.ID = event.source.value[cosyElement];
              }
            }
            if (typeof attributeDetails[3] != 'undefined' && attributeDetails[3] && attributeDetails[3] == 'DisplayName' && event.source.value[cosyElement] != "Keinen Eintrag gefunden") {
              //this.ie.Values[0].Value = event.source.value[cosyElement];
              //sr.displayName = this.ie.Values[0].Value;
              sr.displayName = event.source.value[cosyElement];
              this.ieValue = sr.displayName;
            }
          }
        });
        this.cosyCommunicationControllerService.searchResult.push(sr);
        this.flexboxInput.nativeElement.value = this.ieValue;
      }
    }
  }

  removeOption(option) {
    let index = this.cosyCommunicationControllerService.searchOption.indexOf(option);
    if (index >= 0) this.cosyCommunicationControllerService.searchOption.splice(index, 1);
    let searchText: string = '';
    this.cosyCommunicationControllerService.searchOption.forEach(element => searchText += element.searchString);
    this.uxControllerService.fetchIEUserAction(this.ie.Attributes.OnSelectUAID, this.ie, searchText, null, null, null, this.entityFormGroup, null);
    this.focusOnPlaceInput();
  }

  focusOnPlaceInput() {
    this.flexboxInput.nativeElement.focus();
    this.flexboxInput.nativeElement.value = '';
  }

  configFilters(): FlexSearchRequest {
    let flexSearchRequest: FlexSearchRequest = new FlexSearchRequest();
    flexSearchRequest.filters = [];
    let filterData: Filter = new Filter();
    filterData.type = 'DataRealms';
    filterData.enabled = false;
    flexSearchRequest.filters.push(filterData)
    let filterCol: Filter = new Filter();
    filterCol.type = 'Collections';
    filterCol.enabled = false;
    flexSearchRequest.filters.push(filterCol)
    let filterItem: Filter = new Filter();
    filterItem.type = 'Items';
    filterItem.enabled = true;
    flexSearchRequest.filters.push(filterItem)
    return flexSearchRequest;
  }

  resetFlexbox() {
    setTimeout(() => {
      this.flexboxInput.nativeElement.value = this.ieValue;
    }, 10);
  }

  clearFlexbox() {
    this.flexboxInput.nativeElement.value = "";
  }

}
